import { useState } from 'react';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { createOption, EnterpriseLink } from '@mews-commander/ui';
import { lt, useDialog, useLocalizeProperty } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DropDownButton, DropdownItem } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { PolymorphicProductDialog } from '../../../../../productServiceOrder/components/ProductServiceOrderDialog/AddProduct/PolymorphicProductDialog';

export const AddButton = ({ customerId }: { customerId: string }) => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    const lp = useLocalizeProperty();
    const [{ onClose, active }, toggleDialog] = useDialog();
    const [currentServiceId, setCurrentServiceId] = useState<string | null>(null);

    const { data: serviceOptions } = useRepositorySuspenseQuery(
        'services',
        'getAll',
        { enterpriseIds: [currentEnterpriseId] },
        {
            select: ({ services }) => services.map(({ id, names }) => createOption({ label: lp(names), value: id })),
        }
    );

    const reservationItem = createOption({
        label: lt(TextKey.Reservation),
        value: TextKey.Reservation,
    });

    const items = [reservationItem, ...serviceOptions];

    const handleServiceClick = (serviceId: string) => {
        setCurrentServiceId(serviceId);
        toggleDialog();
    };

    const handleClose = () => {
        setCurrentServiceId(null);
        onClose();
    };

    return (
        <>
            <DropDownButton variant="tertiary" icon={IconName.PlusSimple} size="medium">
                {items.map(({ value, label }) => {
                    if (value == null) return null;
                    return value === TextKey.Reservation ? (
                        <EnterpriseLink
                            key={value}
                            variant="basic"
                            to="Reservation/Create"
                            search={{ CustomerId: customerId }}
                            underline={false}
                        >
                            <DropdownItem label={label} value={value} />
                        </EnterpriseLink>
                    ) : (
                        <DropdownItem
                            key={value}
                            label={label}
                            value={value}
                            onClick={() => handleServiceClick(value)}
                        />
                    );
                })}
            </DropDownButton>
            {currentServiceId != null && (
                <PolymorphicProductDialog
                    onClose={handleClose}
                    active={active}
                    accountId={customerId}
                    serviceId={currentServiceId}
                />
            )}
        </>
    );
};
